import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HomeSearchService } from 'src/app/services/home-search.service.';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IHomeSearchData } from 'src/app/interfaces';
import { AuthService } from 'src/app/auth';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';

export interface IHomeSearchDataDialog {
  typesData: { id: string; name: string }[];
  typeDefault: string;
  results: IHomeSearchData;
  showItems: number;
  reseted: boolean;
}
@Component({
  selector: 'home-search',
  templateUrl: './home-search.component.html',
  styleUrls: ['./home-search.component.scss']
})
export class HomeSearchComponent implements OnInit {
  destroyed$: Subject<boolean> = new Subject<boolean>();
  public searchForm: FormGroup;
  private numberItems = 10;
  private isExternal: boolean;
  private typeFilter = '';
  public twoColumnsClass = true;

  constructor(
    private homeSearchResults: HomeSearchService,
    public dialogRef: MatDialogRef<HomeSearchComponent>,
    private formBuilder: FormBuilder,
    private utilService: UtilService,
    private authService: AuthService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: IHomeSearchDataDialog
  ) { }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      types: [{ value: this.dialogRef.componentInstance.data.typeDefault }, Validators.required],
      search: ['', Validators.minLength(3)]
    });
    this.searchForm.get('search').valueChanges.subscribe(selectedValue => {
      this.searchForm.controls.search.setErrors(null);
    });
    this.isExternal = this.authService.getRole().suffix === '-pymes';
  }

  closeDialog() {
    this.dialogRef.close();
  }

  reset() {
    this.dialogRef.componentInstance.data.reseted = true;
    this.searchForm.controls.search.setValue('');
  }

  showMoreResults() {
    this.dialogRef.componentInstance.data.showItems += this.numberItems;
  }

  search() {
    const search = this.searchForm.value.search.trim();
    if (search.length >= 3) {
      this.dialogRef.componentInstance.data.reseted = false;
      // TODO: no coge el valor por defecto de 'types' la primera vez y retorna un objeto
      this.typeFilter = this.searchForm.value.types
        ? this.searchForm.value.types.value
          ? this.searchForm.value.types.value
          : this.searchForm.value.types
        : this.dialogRef.componentInstance.data.typeDefault;

      const params = {
        PageNumber: 1,
        NumOfElements: 1000000,
        Cif_Filter: this.typeFilter === 'Cif_Filter' ? search : '',
        CuentaNegociadora_Filter: this.typeFilter === 'CuentaNegociadora_Filter' ? search : '',
        Cups_Filter: this.typeFilter === 'Cups_Filter' ? search : '',
        RazonSocial_Filter: this.typeFilter === 'RazonSocial_Filter' ? search : ''
      };

      this.twoColumnsClass = this.typeFilter === 'RazonSocial_Filter' || this.typeFilter === 'Cif_Filter';

      this.homeSearchResults
        .getSocialReasonsList(params)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
          res => {
            this.dialogRef.componentInstance.data = {
              typesData: this.dialogRef.componentInstance.data.typesData,
              typeDefault: this.dialogRef.componentInstance.data.typeDefault,
              results: res.data,
              showItems: this.numberItems,
              reseted: false
            };
          },
          error => {
            this.utilService.toastErrors(error);
          }
        );
    } else {
      this.searchForm.controls.search.setErrors({ minlength: true });
    }
  }

  public handleSelect(data): void {
    const type = this.searchForm.value.types
      ? this.searchForm.value.types.value
        ? this.searchForm.value.types.value
        : this.searchForm.value.types
      : this.dialogRef.componentInstance.data.typeDefault;
    if (this.isExternal) {
      if (type === 'Cif_Filter') {
        this.router.navigate(['customers'], { queryParams: { cif: data.cifRazonSocial } });
      } else if (type === 'RazonSocial_Filter') {
        this.router.navigate(['customers'], { queryParams: { nameSocialReason: data.nombre } });
      } else if (type === 'Cups_Filter') {
        this.router.navigate(['customers/all/pymes'], { queryParams: { idInstallation: data.id } });
      }
    } else {
      if (type === 'Cif_Filter') {
        this.router.navigate(['customers/all/internal'], { queryParams: { idSocialReason: data.id } });
      } else if (type === 'RazonSocial_Filter') {
        this.router.navigate(['customers/all/internal'], { queryParams: { idSocialReason: data.id } });
      } else if (type === 'CuentaNegociadora_Filter') {
        this.router.navigate(['customers'], { queryParams: { tradingAccount: data.id } });
      }
    }
    this.closeDialog();
  }
}
